import React from "react";
import { useNavigate } from "react-router-dom";
import pllogin from "../../Assets/seoimg/login.svg";
import { useTranslation } from "react-i18next";

const PlLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gotologin = () => {
    navigate("/login");
  };

  return (
    <div className="pllogin-div">
      <div className="pllogin">
        <div>
          <img src={pllogin} alt="please login img"></img>
        </div>
        <div className="pl-con">
          <div>
            <h1>{t("pl_login.title")}</h1>
            <p
              dangerouslySetInnerHTML={{ __html: t("pl_login.description") }}
            ></p>
            <button className="cm-btn" onClick={gotologin}>
              {t("pl_login.button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlLogin;
